import React, { useReducer, useState, useEffect } from 'react';
// import './AddUser.modules.css';
import style from './Register.module.css';
import axios from '../../functions/axios';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useLogout } from '../../hooks/useLogout';

function EditUser() {
  const { user } = useAuthContext();

  const formReducer = (state, event) => {
    const form = {
      ...state,
      [event.name]: event.value,
    };
    if (!event.value) {
      delete form[event.name];
    }
    return form;
  };

  const [formData, setFormData] = useReducer(formReducer, {
    userName: user?.userName,
    surName: user?.surName,
    // email: user.email,
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { logout } = useLogout();

  if (!user) {
    navigate('/login');
    return null;
  }

  const validateData = () => {
    if (!formData.oldPassword) {
      return setError('Obecne hasło jest wymagane');
    }
    if (formData.password) {
      if (formData.password.length < 8 || formData.password !== formData.passwordConfirm)
        return false;
    }
    return formData.userName && formData.surName;
  };

  const handleSubmit = async (event) => {
    if (!user) return;
    event.preventDefault();
    event.stopPropagation();
    setSubmitting(true);

    if (!validateData()) return;
    const response = await axios.patch(`/user`, formData);
    if (response.data.error) {
      setError(response.data.error);
      return;
    }
    setTimeout(() => {
      setSubmitting(false);
    }, 3000);
    logout();
    navigate('/login');
  };

  const handleChange = (event) => {
    setError(null);
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  return (
    <div className={style.wrapper}>
      <form>
        <div className={style.section}>
          <h1>Edycja użytkownika</h1>
          <br />
          <div className={style.category}>Dane użytkownika</div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='userName-data'>
              Nazwa użytkownika:
            </label>
            <input
              id='userName-data'
              placeholder='nazwa użytkownika'
              name='userName'
              onChange={handleChange}
              value={formData.userName || user?.userName || ''}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='surName-data'>
              Imię i nazwisko:
            </label>
            <input placeholder='Imię i nazwisko' name='surName' onChange={handleChange} value={formData.surName || user?.surName || ''} />
          </div>
        </div>
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='oldPassword'>
            Obecne hasło:
          </label>
          <input
            id='oldPassword'
            minLength={8}
            placeholder='Podaj obecne hasło'
            name='oldPassword'
            type='password'
            onChange={handleChange}
            value={formData.oldPassword || ''}
          />
        </div>
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='password'>
            Nowe hasło:
          </label>
          <input
            id='password'
            minLength={8}
            placeholder='Podaj nowe hasło'
            name='password'
            type='password'
            onChange={handleChange}
            value={formData.password || ''}
          />
        </div>
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='passwordConfirm'>
            Powtórz nowe hasło:
          </label>
          <input name='passwordConfirm' placeholder='Powtórz nowe hasło' type='password' onChange={handleChange} value={formData.passwordConfirm || ''} />
        </div>
        <hr />
        <h6 className={style.errorText}>Po kliknięcu "Zapisz" nastąpi wylogowanie</h6>
        <div className={style.buttons}>
          <button className='btn btn-default' onClick={navigate.bind(null, '/', { state: { date: formData.day } })}>
            Anuluj
          </button>
          <p className={style.errorText}>{error}</p>
          <button className='btn btn-default' type='submit' onClick={handleSubmit}>
            Zapisz
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditUser;
